import Request from '@hotmart/request'
import { TOS_REQUEST_IDENTIFIERS } from './tos.constants'

Request.register(`${process.env.API_TOS}/v1/tos`, {
  get: {
    [TOS_REQUEST_IDENTIFIERS.FEATURES]: '/feature'
  }
})
